// Les fonctions uiles
import axios from "../backend/vue-axios/axios";
import dayjs from "dayjs"

const headers = {
    headers: {'Authorization': 'Bearer ' + localStorage.token}
}

export default {
    // The install method will be called with the Vue constructor as
    // the first argument, along with possible options
    install(Vue) {

        Vue.prototype.$createPayments = (family_id, type, period) => {
            return new Promise((resolve, reject) => {
                axios.get('/families/' + family_id + '/create-payments?period=' + period + '&type=' + type, {headers: {'Authorization': 'Bearer ' + localStorage.token}})
                    .then(request => {
                        resolve(request.data)
                    })
                    .catch(error => {
                    })
            })
        }

        /**
         *
         *  Permet de savoir si la signature a expirée pour rediriger sur la page de login
         *
         * @param message
         * @returns {boolean}
         */
        Vue.prototype.$isSignatureExpired = (message) => {
            return message === "Signature has expired";
        }

        Vue.prototype.$addRespToUser = (user_id, resp_id) => {
            return new Promise((resolve, reject) => {
                axios.get('/users/' + user_id + '/add_resp?id=' + resp_id, {headers: {'Authorization': 'Bearer ' + localStorage.token}})
                    .then(request => {
                        resolve(request.data)
                    })
                    .catch(error => {
                    })
            })
        }

        Vue.prototype.$deleteRespFromUser = (user_id, resp_id) => {
            return new Promise((resolve, reject) => {
                axios.get('/users/' + user_id + '/delete_resp?id=' + resp_id, {headers: {'Authorization': 'Bearer ' + localStorage.token}})
                    .then(request => {
                        resolve(request.data)
                    })
                    .catch(error => {
                    })
            })
        }

        Vue.prototype.$getUsers = (family_id) => {
            return new Promise((resolve, reject) => {
                axios.get('/get-majors?family_id=' + family_id, {headers: {'Authorization': 'Bearer ' + localStorage.token}})
                    .then(request => {
                        resolve(request.data)
                    })
                    .catch(error => {
                    })
            })
        }


        Vue.prototype.$addCourseToUser = (user_id, course_id) => {
            return new Promise((resolve, reject) => {
                axios.get('/users/' + user_id + '/course-subscription?id=' + course_id, {headers: {'Authorization': 'Bearer ' + localStorage.token}})
                    .then(request => {
                        resolve(request.data)
                    })
                    .catch(error => {
                    })
            })
        }

        Vue.prototype.$deleteCourseOfUser = (user_id, course_id) => {
            return new Promise((resolve, reject) => {
                axios.get('/users/' + user_id + '/delete-course?id=' + course_id, {headers: {'Authorization': 'Bearer ' + localStorage.token}})
                    .then(request => {
                        resolve(request.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        }

        Vue.prototype.$registerNewFamily = (fields) => {
            return new Promise((resolve, reject) => {
                axios.post('/registration', {family: fields})
                    .then(request => {
                        resolve(request.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        }

        /**
         *
         * permet de créer un certificat médical
         *
         * @param id {Number} ID du user
         * @param formData {FormData} Objet FormData contenant le fichier et l'année
         * @returns {Promise<unknown>}
         */
        Vue.prototype.$createCertificate = (id, formData) => {
            return new Promise((resolve, reject) => {
                axios.post('/users/' + id + '/medical_certificates', formData, headers)
                    .then(request => {
                        resolve(request.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        };

        /**
         *
         * permet de mettre à jour un certificat médical
         *
         * @param user_id
         * @param id {Number} ID du user
         * @param fields
         * @returns {Promise<unknown>}
         */
        Vue.prototype.$updateCertificate = (user_id, id, fields) => {
            return new Promise((resolve, reject) => {
                axios.patch('/users/' + user_id + '/medical_certificates/' + id, fields, headers)
                    .then(request => {
                        resolve(request.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        };


        /**
         *
         * Supprime un model dans la BDD
         *
         * @param model {String} Le model à supprimer
         * @param id {Number} ID du model
         * @returns {Promise<unknown>}
         */
        Vue.prototype.$deleteModel = (model, id) => {
            return new Promise((resolve, reject) => {
                axios.delete('/' + model + '/' + id, headers)
                    .then(request => {
                        resolve(request.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        }

        /**
         *
         * Créer un model
         *
         * @param model {String}
         * @param fields {Object}
         * @returns {Promise<unknown>}
         */
        Vue.prototype.$createModel = (model, fields = {}) => {
            return new Promise((resolve, reject) => {
                axios.post('/' + model, fields, headers)
                    .then(request => {
                        resolve(request.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        };

        /**
         *
         * Permet de récupérer un model
         *
         * @param model {String}
         * @param id {Number} Si présent, permet de récupérer un model précis. Sinon, récupère la liste
         * @returns {Promise<unknown>}
         */

        Vue.prototype.$getModel = (model, id = null) => {
            if (id === null) {
                return new Promise((resolve, reject) => {
                    axios.get('/' + model, {headers: {'Authorization': 'Bearer ' + localStorage.token}})
                        .then(request => {
                            resolve(request.data)
                        })
                        .catch(error => {
                            reject(error)
                        })
                })
            } else {
                return new Promise((resolve, reject) => {
                    axios.get('/' + model + '/' + id, headers)
                        .then(request => {
                            resolve(request.data)
                        })
                        .catch(error => {
                            reject(error)
                        })
                })
            }

        };

        /**
         *
         * Modifie un model existant
         *
         * @param model {String}
         * @param fields {Object}
         * @param id {Number}
         * @returns {Promise<unknown>}
         */

        Vue.prototype.$updateModel = (model, fields, id) => {
            return new Promise((resolve, reject) => {
                axios.put('/' + model + '/' + id, fields, headers)
                    .then(request => {
                        resolve(request.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        };


        Vue.prototype.$sexyHour = (time) => {
            let date = new Date(time);
            let heure = date.getHours();
            let minutes = date.getMinutes();
            if (minutes < 10)
                minutes = "0" + minutes;
            return heure + ":" + minutes;
        };

        Vue.prototype.$sexyName = (firstname, name) => {
            return firstname.charAt(0).toUpperCase() + firstname.slice(1) + ' ' + name.toUpperCase()
        }

        Vue.prototype.$sexyDate = (time, type) => {
            let date = new Date();
            let yesterday = new Date();
            let messageDate = new Date(time)
            yesterday = new Date(yesterday.setDate(yesterday.getDate() - 1));
            let mois = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];

            let day = messageDate.getDate(),
                month = mois[messageDate.getMonth()],
                year = messageDate.getFullYear(),
                hours = messageDate.getHours(),
                mins,
                message;
            mins = parseInt(messageDate.getMinutes());

            // On test si les minutes sont inférieures à 10 pour afficher le 0 devant le chiffre
            if (mins < 10) {
                mins = '0' + mins;
            }
            if (hours < 10) {
                hours = '0' + hours;
            }

            if (type === 'history') {

                return message = "le " + day + " " + month + " " + year + " à " + hours + ":" + mins;

            } else if (type === "messages") {

                if (yesterday.toDateString() === messageDate.toDateString()) {
                    return message = "Hier"
                } else if (date.toDateString() === messageDate.toDateString()) {
                    return message = "Aujourd'hui"
                } else {

                    if (date.getFullYear() != messageDate.getFullYear()) {
                        year = " " + updateDate.getFullYear();
                    } else {
                        year = '';
                    }
                    return message = "le " + day + " " + month + " " + year;
                }


                // On test si les minutes sont inférieures à 10 pour afficher le 0 devant le chiffre

            } else {


                if (date.toDateString() === messageDate.toDateString()) {
                    let diff = (date.getTime() - messageDate.getTime()) / 1000;
                    if (diff < 3600) {
                        if (diff < 60) {
                            message = "Dernière modification il y a moins d'une minute.";
                            return message;
                        } else {
                            message = "Dernière modification il y a " + Math.round(diff / 60) + " minutes.";
                            return message;
                        }
                    } else {
                        day = "aujourd'hui";
                    }
                } else if (yesterday.toDateString() === messageDate.toDateString()) {
                    day = "hier";
                } else {
                    day = "le " + messageDate.getDate() + " " + mois[messageDate.getMonth()];
                }
                if (date.getFullYear() != messageDate.getFullYear()) {
                    year = " " + messageDate.getFullYear();
                } else {
                    year = '';
                }
                message = "Dernière modification " + day + year + " à " + hours + ":" + min;
                return message;
            }
        }

        Vue.prototype.$sameDay = (d1, d2) => {
            d1 = new Date(d1)
            d2 = new Date(d2)
            return d1.getFullYear() === d2.getFullYear() &&
                d1.getMonth() === d2.getMonth() &&
                d1.getDate() === d2.getDate();
        };

        Vue.prototype.$getAge = (birthDate) => {
            let date = new Date(birthDate)
            let ageDifMs = Date.now() - date.getTime();
            let ageDate = new Date(ageDifMs); // miliseconds from epoch

            return Math.abs(ageDate.getUTCFullYear() - 1970);
        }

        Vue.prototype.$birthDate = (date) => {
            return new Intl.DateTimeFormat(['fr']).format(new Date(date))
        }


        /**
         * Trouve dans quel trimestre on se trouve
         * @return {Number} - Renvoie le trimestre en cours
         */
        Vue.prototype.$currentTrimestre = () => {
            let today = new Date()
            let year1
            let year2

            // si on est entre Septembre et Décembre
            if (today.getMonth() >= 8) {

                // on garde la date actuelle et on ajoute 1 an pour le T2 et T3
                year1 = today.getFullYear()
                year2 = today.getFullYear() + 1

                // sinon on est la deuxième portion de l'année
            } else {

                // le début de l'année scolare est année en cours - 1
                year1 = today.getFullYear() - 1
                year2 = today.getFullYear()
            }

            //date de debut T1 01 Septembre
            let begint1 = new Date(year1, 8, 1)
            // date de fin de T1 18 Décembre
            let endt1 = new Date(year1, 11, 18)
            //date de fin T2 31 Mars
            let endt2 = new Date(year2, 2, 31)
            //date de fin T3 30 Juin
            let endt3 = new Date(year2, 7, 30)

            if (today >= begint1 && today <= endt1) {
                return 1
            } else if (today > endt1 && today <= endt2) {
                return 2
            } else if (today > endt2 && today <= endt3) {
                return 3
            } else {
                return 3
            }


        }

        Vue.prototype.$formatTel = (body, end = '.') => {

            let length = 2
            let chunklen = parseInt(length, 10) || 76;

            end = end || '\r\n';

            if (chunklen < 1) {
                return false;
            }

            let str = body.match(new RegExp(".{0," + chunklen + "}", "g")).join(end);

            return str.substring(0, str.length - 1)
        }

        /**
         * Function to sort alphabetically an array of objects by some specific key.
         *
         * @param {String} property Key of the object to sort.
         */
        Vue.prototype.$dynamicSort = (property) => {
            let sortOrder = 1;

            if (property[0] === "-") {
                sortOrder = -1;
                property = property.substr(1);
            }

            return function (a, b) {
                if (sortOrder === -1) {
                    return b[property].localeCompare(a[property]);
                } else {
                    return a[property].localeCompare(b[property]);
                }
            }
        }

        /**
         * Retourne une fonction qui, tant qu'elle est appelée,
         * n'est exécutée au plus qu'une fois toutes les N millisecondes.
         * Paramètres :
         *  - func : la fonction à contrôler
         *  - wait : le nombre de millisecondes (période N) à attendre avant
         *           de pouvoir exécuter à nouveau la function func()
         *  - leading (optionnel) : Appeler également func() à la première
         *                          invocation (Faux par défaut)
         *  - trailing (optionnel) : Appeler également func() à la dernière
         *                           invocation (Faux par défaut)
         *  - context (optionnel) : le contexte dans lequel appeler func()
         *                          (this par défaut)
         */
        Vue.prototype.$throttle = (func, wait, leading, trailing, context) => {
            let ctx, args, result;
            let timeout = null;
            let previous = 0;
            const later = function () {
                previous = new Date;
                timeout = null;
                result = func.apply(ctx, args);
            };
            return function () {
                const now = new Date;
                if (!previous && !leading) previous = now;
                const remaining = wait - (now - previous);
                ctx = context || this;
                args = arguments;
                // Si la période d'attente est écoulée
                if (remaining <= 0) {
                    // Réinitialiser les compteurs
                    clearTimeout(timeout);
                    timeout = null;
                    // Enregistrer le moment du dernier appel
                    previous = now;
                    // Appeler la fonction
                    result = func.apply(ctx, args);
                } else if (!timeout && trailing) {
                    // Sinon on s’endort pendant le temps restant
                    timeout = setTimeout(later, remaining);
                }
                return result;
            };
        }

        /**
         *
         * Permet de savoir si la date (dateCheck) est entre deux dates
         *
         * @param dateFrom {Date} - la date de départ
         * @param dateTo {Date} - la date de fin
         * @param dateCheck {Date} - la date à checker
         *
         * @return {Boolean}
         */
        Vue.prototype.$isDateInRange = (dateFrom, dateTo, dateCheck) => {
            let from = new Date(dateFrom)
            let to = new Date(dateTo)
            let check
            if (dateCheck !== undefined) {
                check = new Date(new Date(dateCheck).getUTCFullYear(), new Date(dateCheck).getMonth(), new Date(dateCheck).getUTCDate())
            } else {
                check = new Date(new Date().getUTCFullYear(), new Date().getMonth(), new Date().getUTCDate())
            }
            return check >= from && check <= to
        }


        Vue.prototype.$getHeaders = () => {
            return {
                baseURL: process.env.NODE_ENV === "development" ? 'http://localhost:3000' : 'https://richendanse-api-studio-uni.herokuapp.com',
                headers: {
                    'Authorization': 'Bearer ' + localStorage.token
                }
            }
        }

        // Vue.prototype.$getNumberToHours = (number) => {
        //     let c = this.course
        //     let amount = parseInt(c.hour / 2)
        //     let isDemi = ''
        //     if (c.hour % 2 === 1)
        //         isDemi = '30'
        //     let timeStart = amount + 'h' + isDemi
        //
        //     let amountEnd = parseInt(c.hour / 2 + c.duration)
        //     let isDemiEnd = ''
        //     if ((c.hour + c.duration*2) % 2 === 1)
        //         isDemiEnd = "30"
        //     let timeEnd = amountEnd + 'h' + isDemiEnd
        //     let time = 'de ' + timeStart + ' à ' + timeEnd
        //     c.time = time
        //
        // }


    }


}






